/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Due_HoursInputs */

const cs_field_due_hours = /** @type {(inputs: Field_Due_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termín za (hodiny)`)
};

const en_field_due_hours = /** @type {(inputs: Field_Due_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due in (hours)`)
};

/**
* | output |
* | --- |
* | "Due in (hours)" |
*
* @param {Field_Due_HoursInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_due_hours = /** @type {((inputs?: Field_Due_HoursInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Due_HoursInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_due_hours(inputs)
	return cs_field_due_hours(inputs)
});